angular.module('ui-ng-draggable').directive('phxDraggableList', function (phxDraggableService, ngScreenQueryServant) {
  var events = {
    cancel: false,
    cloned: false,
    drag: false,
    dragend: false,
    drop: false,
    out: false,
    over: false,
    remove: false,
    shadow: false
  };

  return {
    restrict: 'E',
    scope: {
      identifier: '@',
      onCancel: '&?',
      onCloned: '&?',
      onDrag: '&?',
      onDragend: '&?',
      onDrop: '&?',
      onOut: '&?',
      onOver: '&?',
      onRemove: '&?',
      onShadow: '&?'
    },
    link: function (scope, el, attrs) {
      if (ngScreenQueryServant.isScreenMobile()) {
        return;
      }

      phxDraggableService.addContainer(el[0], attrs.identifier, attrs.nonDraggableTag);

      var drake = phxDraggableService.getDrake(scope.identifier) || {};

      _.map(Object.keys(events), function (event) {
        var methodName = 'on' + event.charAt(0).toUpperCase() + event.slice(1);

        if (_.isEmpty(drake) || events[event] || !_.has(scope, methodName)) {
          return;
        }

        events[event] = true;

        drake.on(event, function () {
          try {
            scope[methodName]({ args: arguments });
          } catch (e) {}
        });
      });

      scope.$on('$destroy', () => {
        phxDraggableService.removeContainer(el[0], attrs.identifier);
        const shouldClearDrake = drake.containers.length === 0;
        if (!shouldClearDrake) {
          return;
        }
        _.map(Object.keys(events), (event) => {
          drake.off(event);
          events[event] = false;
        });
        phxDraggableService.clearDrake(attrs.identifier);
      });
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-draggable/src/components/dragula_component.js